import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'

export default async function (data) {
	const node = data.node;
	// const title = node.title;
	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	const background = await getBackground(data?.customTheme, 'theme')

	return {
		"id": id,
		"elements": [
			{
				"type": "text",
				"id": "IQxPxkTPZ0",
				"left": 242.2550096841478,
				"top": 162.24999999999997,
				"width": 503.5756853396901,
				"height": 119,
				"content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 66px;\"><span style=\"color: rgba(255,254,254,1);\">谢谢观看</span></span></strong></p>",
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"vertical": false
			}
		],
		background
	};

}